import axios from "axios";
import { ARQUIVOS_DIGITALIZADOS_LIST, ARQUIVOS_DIGITALIZADOS_LIST_FAILED } from "./Events";
import { toDoWithForms, notifyApiError } from './utils';

export function list(filter) {
  return function (dispatch) {
    const request = axios.post(`/PublicArquivoDigitalizado/List`, filter);

    request
      .then(response => {
        dispatch({ type: ARQUIVOS_DIGITALIZADOS_LIST, payload: response.data });
      })
      .catch((error) => {
        const message = notifyApiError(error, 'Não foi possível carregar os arquivos digitalizados');
        dispatch({ type: ARQUIVOS_DIGITALIZADOS_LIST_FAILED, payload: message });
      });
  };
}

export function identifyOnExtent(geographicExtent, successCallback) {
  return function (dispatch) {
    const request = axios.post(`/PublicArquivoDigitalizado/IdentifyOnExtent`, geographicExtent);

    request
      .then(response => {
        
        if (successCallback) {
          successCallback(response);
        }
      })
      .catch(() => {

      });
  };
}

export function clearResults() {
  return function (dispatch) {
    dispatch({ type: ARQUIVOS_DIGITALIZADOS_LIST, payload: null });
  };
}

export function download(id) {
  return function (dispatch) {
    toDoWithForms( `/PublicArquivos/Download/${id}`);
  }
}